"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuctionHeaderSchema = exports.BidSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const primitives_1 = require("./primitives");
exports.BidSchema = typebox_1.Type.Object({
    routerVersion: typebox_1.Type.String(),
    transferId: typebox_1.Type.String(),
    origin: typebox_1.Type.String(),
    router: primitives_1.TAddress,
    // Array indexed by auction round (determines how many router(s) the sequencer may split the transfer between).
    signatures: typebox_1.Type.Record(primitives_1.TIntegerString, typebox_1.Type.String()),
});
/// MARK - Auctions Cache Types ---------------------------------------------------------------------
// Auction metadata, reflected in the header for auctions API and the auction cache.
exports.AuctionHeaderSchema = typebox_1.Type.Object({
    // Timestamp of auction start.
    timestamp: typebox_1.Type.String(),
    // Origin domain of transfer.
    origin: typebox_1.Type.String(),
    // Destination domain of transfer.
    destination: typebox_1.Type.String(),
});
/// -------------------------------------------------------------------------------------------------
//# sourceMappingURL=auctions.js.map